<template>
	<div class="sxzxList">
        <div class="bt">
            <h3>实训中心</h3>
            <span>TRAINING CENTER</span>
            <img src="../assets/img/icon_bt.png" alt="">
        </div>
        <div class="sxzxBoxList"  :style="{position: 'relative',height: styles.height+'rem'}" >
        <div class="swiper-container" :style="{width: styles.width+'rem', position: 'absolute',height: styles.height+'rem',left: '50%',marginLeft: '-6rem'}">
            <div class="swiper-wrapper">
                <div v-for="(item, index) in sxzxList" :key="index"    class="swiper-slide" >
                    <router-link :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"   >
                      <img :src="item.FileUrl"   />
                    <p class="txt-cut1">{{ item.Title }}</p>
                    </router-link>
                </div>
            </div>
        <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div  v-if="sliderList.length>1" class="swiper-button-prev" style="left: 50%; margin-left: -620px"></div>
        <div  v-if="sliderList.length>1" class="swiper-button-next" style="left: 50%; margin-left: 600px"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
        </div>
        </div>
        <div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s">
            <router-link :to="moreLink"><em>查看更多></em></router-link>
        </div>
	</div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

// import 'swiper/css/swiper.min.css';
export default {
  name: 'sxzx',
  props: {
   sxzxList: { // 图片列表 src数组
      type: Array,
      default: () => []
    },
    moreLink: {
      type: String,
      default: "",
    },
    isShowPosition: { // 是否显示下方小圆点
      type: Boolean,
      default: true
    },
    isShowLeftOrRightBtn: { // 是否显示左右按钮
      type: Boolean,
      default: true
    },
    duration: { // 切换间隔
      type: [Number, String],
      default: 5000
    },
    animationT: {
     type: Object,
     default: () => {
        return {
          speed: 20,
          speedTime: 20
        }
      }
    },
    styles: { // 自定义轮播图片宽高 默认500*300
      type: Object,
      default: () => {
        return {
          width: 12,
          height: 4.5
        }
      }
    }
  },
  data () {
    return {
      active: 1, // 当前轮播图片
      timer: null,// 定时器
      len: 1,
      screenWidthtimer: false,
      screenWidth: document.body.clientWidth, // 屏幕宽度
    }
  },
   mounted () {
    if(this.sxzxList.length>1){
      var mySwiper3 = new Swiper ('.sxzxBoxList .swiper-container', {
          loop: true,
          autoplay: false,
          observer: true,
          observeSlideChildren: true,
          slidesPerView: 'auto',
          centeredSlides: true,
          // 如果需要分页器
          pagination: '.sxzxBoxList .swiper-pagination',
          // 如果需要前进后退按钮
      
          nextButton: '.sxzxBoxList .swiper-button-next',
          prevButton: '.sxzxBoxList .swiper-button-prev',
      })
    } 
    
  },

}
</script>

<style>
.sxzxList{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.sxzxList .sxzxBoxList .swiper-slide{
  width: 5.9rem;
  height: 4.5rem;
  box-shadow: 0rem 0.06rem 0.27rem 0rem 
  rgba(158, 158, 158, 0.13);
  -webkit-transition: transform 1.0s;
  -moz-transition: transform 1.0s;
  position: relative;
}
.sxzxList .sxzxBoxList .swiper-slide a{
  display: block;
}
.sxzxList .sxzxBoxList .swiper-slide a img{
  display: block;
  width: 5.9rem;
  height: 3.9rem;
  object-fit: cover;
}
.sxzxList .sxzxBoxList .swiper-slide a p{
  font-size: 0.26rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.6rem;
  letter-spacing: 0.02rem;
  color: #333333;
  text-align: center;
  background-color: #fff;
}
.sxzxList .sxzxBoxList .swiper-slide.swiper-slide-prev {
  transform: scale(0.8);
  left: 0.3rem;
}
.sxzxList .sxzxBoxList .swiper-slide.swiper-slide-next {
  transform: scale(0.8);
  right: 0.3rem;
}
.sxzxList .more{
	width: 2rem;
	height: 0.7rem;
	border-radius: 0.05rem;
	border: solid 0.01rem #0376be;
	display: block;
	margin: 0 auto;
	margin-top: 0.6rem;
	margin-bottom: 0.7rem;
	box-sizing: border-box;
}
.sxzxList .more a{
	display: block;
	font-size: 0.26rem;
	font-weight: normal;
	font-stretch: normal;
	line-height: 0.68rem;
	letter-spacing: 0.03rem;
	color: #0376be;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/sxzx.vue